var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavTabs',{staticClass:"kind-tabs",attrs:{"list":_vm.list,"spaceAround":true},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }